import { put, select } from "redux-saga/effects";

import { getTmSelectedId, getTmSelectedOuterNodeId } from "domains/transformationMap/selectors";
import type { TopicVideoApplySearchCriteriaAction } from "domains/videos/actionTypes";
import { getVideoSearchCriteria } from "domains/videos/selectors";
import { fetchVideosForTopic } from "entities/videos/actions";

export function* applyVideoSearchCriteriaSaga(action: TopicVideoApplySearchCriteriaAction) {
  const searchCriteria: ReturnType<typeof getVideoSearchCriteria> = yield select(getVideoSearchCriteria);
  const tmSelectedId: ReturnType<typeof getTmSelectedId> = yield select(getTmSelectedId);
  const secondaryTopicId: ReturnType<typeof getTmSelectedOuterNodeId> = yield select(getTmSelectedOuterNodeId);

  const id = action.payload?.topicId ?? tmSelectedId;
  if (id !== undefined) yield put(fetchVideosForTopic({ ...searchCriteria, id, secondaryTopicId }, action.meta));
}
